/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text } from './Text';
import { Title } from './Title';

const BuySellOrderInProgress = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'successBlue'} />
      <Title>{t('NOTIFICATION_BUY_SELL_ORDER_IN_PROGRESS__title')}</Title>
      <Text>{t('NOTIFICATION_BUY_SELL_ORDER_IN_PROGRESS__desc')}</Text>
    </>
  );
};

export { BuySellOrderInProgress };
